
// Vuex / vue
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace, Getter } from 'vuex-class';


// Components
import vSelect from "vue-select";
import EventFilter from './EventFilter.vue';

// Types
import { EventSearchState, EventType } from '@/store/event-search/types';
import EventSearchModel from "@/types/eventSearch/EventSearchModel";
import { FeaturesList } from '@/store/types';


// Utils
import { get } from "lodash";

// Vuex Modules
const EventSearchStore = namespace("eventSearch");

@Component({
    components: {
        "event-filter": EventFilter,
        "v-select": vSelect,
    }
})
export default class EventTypeFilter extends Vue {
    @Prop({ default: null, type: Object, required: true }) value: EventSearchModel;

    @EventSearchStore.State((s: EventSearchState) => s.SearchableEventTypes) searchableEventTypes!: EventType[];

    @EventSearchStore.Action loadSearchableEventTypes!: () => Promise<void>;

    @Getter("getFeaturesList") featuresList: FeaturesList;

	private allEventTypeFilterOption = {
		eventTypeID: -1,
		title: "All",
		searchable: true,
	};

    /**
     * @summary life cycle hook
     * - gets event types if ff is enabled.
     */
    private async mounted(): Promise<void> {
        if (this.isEventTypeFilteringEnabled) {
			await this.loadSearchableEventTypes();
			this.value.eventTypeId = this.allEventTypeFilterOption.eventTypeID;
		}
    }

    /**
     * @summary computed property to get the event type filter ff status.
     */
	private get isEventTypeFilteringEnabled() {
		return get(this.featuresList, ["Alarms", "EventSearch", "EventTypeFilter"], false);
	}

    /**
     * @summary computed property which contains all event type
     * filter options and searchable event types.
     */
	private get allSearchableEventTypes() {
		return [this.allEventTypeFilterOption, ...this.searchableEventTypes];
	}
}
